import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './pending-teachers.styles'
import Section from '../../../../shared/section/section'
import PendingTeacher from './pending-teacher/pending-teacher.container'
import { Table, HeadCell } from 'pobble-components/dist/table'

class PendingTeachers extends Component {
  render() {
    const { classes, pending, pendingTeachers } = this.props
    return (
      !pending && (
        <Section title="Pending teachers" className={classes.section}>
          {!!pendingTeachers.length && (
            <div className={classes.intro}>
              <p>
                Teachers requesting access to your school, awaiting approval.
              </p>
              <Table>
                <thead>
                  <tr>
                    <HeadCell className={classes.left}>Name</HeadCell>
                    <HeadCell className={classes.left}>
                      Registered email
                    </HeadCell>
                    <HeadCell className={classes.left}>Status</HeadCell>
                    <HeadCell />
                  </tr>
                </thead>
                <tbody>
                  {pendingTeachers.map(pendingTeacher => (
                    <PendingTeacher
                      key={pendingTeacher.account.id}
                      id={pendingTeacher.account.id}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          {!pendingTeachers.length && (
            <p className={classes.empty}>No inactive members.</p>
          )}
        </Section>
      )
    )
  }
}

export default injectSheet(styles)(PendingTeachers)
